import React from 'react';
import TagItem from './TagItem';
// import { tags } from './mockData';
import './styles.scss';

const TagsFilter = ({ tags = [], selectedTag, onClick }) => {
    return (
        <div className="tags-filter">
            <TagItem name="show all" selectedName={selectedTag} onClick={onClick} />
            {tags.map(name => (
                <TagItem key={name} name={name} selectedName={selectedTag} onClick={onClick} />
            ))}
        </div>
    );
};

export default TagsFilter;
